import { CONSTANTS__client } from '@/constants/CONSTANTS__client';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function LayoutMobile({ children, className }: Props) {
  function render_sidebar_navigation() {
    let out = <div className={`h-[${CONSTANTS__client.MOBILE_TOPBAR_HEIGHT}px]`}></div>;

    return out;
  }
  return (
    <div className={`bg-bar pb-5 w-screen h-screen ${className}`}>
      {render_sidebar_navigation()}
      <div className="w-full !h-[calc(100vh-70px)] flex flex-col justify-between">
        <div className={`px-5 w-full h-full`}>{children}</div>
      </div>
    </div>
  );
}
